<template>
  <v-toolbar id="core-toolbar" light>
    <div class="v-toolbar-title" v-if="$store.getters.pagetitle">
      <v-toolbar-title class="font-weight-light text-general">
        <v-btn class="default v-btn--simple" icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ $t("language." + $store.getters.pagetitle) }}
      </v-toolbar-title>
    </div>
    <v-spacer />
    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-avatar width="16" height="12" tile>
                <img :src="selectedlocale.icon" :alt="selectedlocale.title" />
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(locale, index) in $store.getters.locales"
              :key="index"
              @click="switchLocale(locale.locale)"
            >
              <v-list-item-title>
                <v-avatar width="16" height="12" tile>
                  <img :src="locale.icon" :alt="locale.title" />
                </v-avatar>
                {{ locale.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          bottom
          left
          content-class
          offset-y
          transition="slide-y-transition"
          v-if="hasInbox"
        >
          <template v-slot:activator="{ on }">
            <router-link v-ripple v-on="on" class="toolbar-items" to="/inbox">
              <v-badge
                color="error"
                overlap
                v-if="$store.getters.inboxcount.total > 0"
              >
                <template slot="badge">{{
                  $store.getters.inboxcount.total
                }}</template>
                <v-icon color>mdi-bell</v-icon>
              </v-badge>
            </router-link>
          </template>
        </v-menu>
        <router-link
          v-ripple
          class="toolbar-items"
          to="/profile"
        >
          <v-icon color>mdi-account</v-icon>
        </router-link>

        <v-icon class="toolbar-items" color @click="logout">mdi-power</v-icon>
      </v-flex>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  data: () => ({
    locale: "en",
    responsive: false,
    responsiveInput: false,
  }),

  computed: {
    ...mapGetters(["authorized"]),
    selectedlocale() {
      return this.$store.getters.locales.filter((item) => {
        return item.locale == this.locale;
      })[0];
    },
    hasInbox() {
      return (
        this.$store.getters.usermenu.filter((item) => {
          return item.textkey == "inbox";
        }).length > 0
      );
    },
  },

  mounted() {
    let storedlocale = localStorage.getItem("locale");
    if (storedlocale != null) this.locale = storedlocale;
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    switchLocale: function(locale) {
      localStorage.setItem("locale", locale);
      this.locale = locale;
      this.$i18n.locale = locale;
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    logout: function() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
.theme--light.v-toolbar {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
}
</style>
